import React from 'react';

const RefundPolicyPage: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto py-12 px-4 sm:px-6 lg:px-8 min-h-screen">
      <h1 className="text-4xl font-extrabold text-amber-800 mb-6 border-b pb-2 font-[Cinzel]">
        Refund Policy
      </h1>
      <p className="text-gray-600 mb-4">
        Effective Date: 1st January 2024
      </p>
      <div className="space-y-6 text-gray-700">
        <h2 className="text-2xl font-semibold text-amber-700 mt-6">
          Eligibility for Refund
        </h2>
        <p>
          Our refund policy allows for returns within 7 days of delivery for all non-customized jewellery items, provided the item is unused and in its original packaging with all tags intact.
        </p>

        <h2 className="text-2xl font-semibold text-amber-700 mt-6">
          Non-Refundable Items
        </h2>
        <p>
          Please note that the following items are not eligible for a refund or return:
        </p>
        <ul className="list-disc ml-6 space-y-2">
          <li>Custom-made or personalized jewellery.</li>
          <li>Items that show signs of wear, damage, or alteration.</li>
          <li>Items returned without the original packaging, tags, or accompanying certificates (e.g., diamond or gemstone certificates).</li>
          <li>Gift cards.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-amber-700 mt-6">
          Return Process
        </h2>
        <p>
          To initiate a return and request a refund, please follow these steps:
        </p>
        <ol className="list-decimal ml-6 space-y-2">
          <li>**Contact Support:** Email our support team at <a href="mailto:ashutoshrajput203@gmail.com" className="text-amber-700 hover:underline font-medium">ashutoshrajput203@gmail.com</a> within the 7-day eligibility period to request a Return Authorization (RA) number.</li>
          <li>Package the Item : Securely pack the item, ensuring the original packaging and all documentation are included. Write the RA number clearly on the outside of the package.</li>
          <li>Shipping : Ship the package using a reputable courier service that provides tracking and insurance. **The customer is responsible for all return shipping costs.**</li>
        </ol>

        <h2 className="text-2xl font-semibold text-amber-700 mt-6">
          Refund Processing
        </h2>
        <p>
          Once we receive your returned item, it will be inspected by our quality assurance team. If the return is approved:
        </p>
        <ul className="list-disc ml-6 space-y-2">
          <li>The refund will be processed to your original method of payment.</li>
          <li>Refunds are typically processed within **5-7 business days** after the returned item is inspected and approved.</li>
          <li>You will receive an email notification once the refund has been initiated. Please note that it may take additional time for your bank or credit card company to post the refund to your account.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-amber-700 mt-6">
          Damaged or Incorrect Items
        </h2>
        <p>
          If you receive an item that is damaged or incorrect, please contact us immediately (within 24 hours of delivery) at <a href="mailto:ashutoshrajput203@gmail.com" className="text-amber-700 hover:underline font-medium">ashutoshrajput203@gmail.com</a> with photographs of the item and its packaging so we can evaluate the issue and make it right.
        </p>
      </div>
    </div>
  );
};

export default RefundPolicyPage;